import { makeAutoObservable } from "mobx";
import { inject, injectable } from "tsyringe";
import { TOKEN_IProjectBus, type IProjectBus } from "@/services/ProjectBus";
import { TOKEN_INavigationState, type INavigationState } from "@/services/NavigationState";

export const TOKEN_NavigationStore = Symbol("NavigationStore");

@injectable()
export class NavigationStore {
    private _projectId?: string;
    private _symmetricKey?: string;
    private _isProjectSelectionRoute: boolean = false;

    constructor(
        @inject(TOKEN_IProjectBus) projectBus: IProjectBus,
        @inject(TOKEN_INavigationState) navigationState: INavigationState,
    ) {
        projectBus.subscribe_userHitBackButton(async () => {
            const navState = navigationState.state;
            this._projectId = navState.projectId;
            this._symmetricKey = navState.symmetricKey;
            this._isProjectSelectionRoute = navState.allProjects;
        });
        makeAutoObservable(this);
    }

    get projectId(): string | undefined {
        return this._projectId;
    }

    get symmetricKey(): string | undefined {
        return this._symmetricKey;
    }

    get isProjectSelectionView(): boolean {
        return this._isProjectSelectionRoute;
    }

}